.user {
  align-items: flex-start;
  display: flex;
  margin: var(--space-medium) 0;
}

.avatar {
  height: var(--avatar-size, 50px);
  margin-right: var(--space-medium);
  min-width:  var(--avatar-size, 50px);
  position: relative;
  width:  var(--avatar-size, 50px);
}

.text {
  font-size: var(--font-size-6);
  line-height: var(--line-size-6);
}

.role,
.info {
  font-size: var(--font-size-7);
  line-height: var(--line-size-7);
}

.info {
  font-style: italic;
}
